/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { ProgressIndicator } from 'sarsaparilla';

interface ProgressType {
    activeStep: number;
    steps: string[];
}
export default function Progress({ activeStep, steps }: ProgressType) {
    return (
        <div className="tp-progress">
            <div className="tp-progress-container">
                <ProgressIndicator activeStep={activeStep} steps={steps} />
            </div>
        </div>
    );
}
